/**
 * Single source of truth for nav labels, page titles, and search placeholders.
 * Sidebar and command bar both read from here so names never drift.
 */
export const NAV_MODULES = [
  {
    path: "/dashboard",
    routeName: "dashboard",
    label: "Dashboard",
    icon: "mdi-view-dashboard-outline",
    searchPlaceholder: "Search organizations, contacts, phone numbers...",
  },
  {
    path: "/organizations",
    routeName: "organizations",
    label: "Organizations",
    icon: "mdi-domain",
    searchPlaceholder: "Search organizations, contacts, phone numbers...",
  },
  {
    path: "/calls",
    routeName: "calls",
    label: "Call History",
    icon: "mdi-phone-log",
    searchPlaceholder: "Search callers, organizations, outcomes...",
  },
  {
    path: "/callers",
    routeName: "callers",
    label: "Unique Callers",
    icon: "mdi-account-voice",
    searchPlaceholder: "Search unique callers, phone numbers, organizations...",
  },
  {
    path: "/users",
    routeName: "users",
    label: "Users",
    icon: "mdi-account-group-outline",
    searchPlaceholder: "Search team members, emails, roles...",
  },
  {
    path: "/sip-numbers",
    routeName: "sip-numbers",
    label: "SIP Numbers",
    icon: "mdi-phone-outline",
    searchPlaceholder: "Search numbers, countries, assignments...",
  },
  {
    path: "/contact-us",
    routeName: "contact-us",
    label: "Contact Us",
    icon: "mdi-email-outline",
    searchPlaceholder: "Search leads, emails, organizations, inquiries...",
    // Inactive: Contact Us GraphQL APIs removed from backend — keep module code, hide from UI
    active: false,
    showInSidebar: false,
  },
  {
    path: "/transactions",
    routeName: "transactions",
    label: "Transaction History",
    icon: "mdi-format-list-text",
    searchPlaceholder: "Search transactions, organizations, references...",
  },
  {
    path: "/audit-logs",
    routeName: "audit-logs",
    label: "Audit Logs",
    icon: "mdi-shield-search",
    searchPlaceholder: "Search audit logs, modules, actors, organizations...",
  },
  {
    path: "/action-templates",
    routeName: "action-templates",
    label: "Action Templates",
    icon: "mdi-puzzle-outline",
    searchPlaceholder: "Search action templates...",
  },
  {
    path: "/channel-dashboard",
    routeName: "channel-dashboard",
    label: "Channel Dashboard",
    icon: "mdi-phone-in-talk-outline",
    searchPlaceholder: "Search channel and call statistics...",
  },
  {
    path: "/settings",
    routeName: "settings",
    label: "Settings",
    icon: "mdi-cog-outline",
    searchPlaceholder: "Search rates, billing parameters...",
  },
];

/** @deprecated use NAV_MODULES entry — kept for imports */
export const SETTINGS_MODULE = NAV_MODULES.find((m) => m.routeName === "settings");

const ALL_MODULES = NAV_MODULES;

export const SIDEBAR_NAV_MODULES = NAV_MODULES.filter(
  (module) => module.active !== false && module.showInSidebar !== false,
);

export function getModuleMetaForPath(path = "") {
  const match = ALL_MODULES.find(
    (module) => path === module.path || path.startsWith(`${module.path}/`)
  );

  if (match) {
    return {
      pageTitle: match.label,
      searchPlaceholder: match.searchPlaceholder,
    };
  }

  return {
    pageTitle: "Yandle",
    searchPlaceholder: "Search...",
  };
}

export function routeMetaForName(routeName) {
  const match = ALL_MODULES.find((module) => module.routeName === routeName);
  if (!match) return {};
  return {
    pageTitle: match.label,
    searchPlaceholder: match.searchPlaceholder,
  };
}
